import { getInitialParams } from './InitialParams';

// This effectively checks a parameter to determine if the page is loaded
// inside a _managed_ embedded iframe, which means that there is a postMessage
// based communication channel with the parent page to do things like resizing
// and showing full-screen overlays.
export default function isEmbeddedFrame(): boolean {
  let { isEmbedded } = getInitialParams();
  return isEmbedded === true;
}
